module.exports = __webpack_public_path__ + "static/media/trading_intelligence.3c14209d.PNG";